import { DirectUploadController } from '@rails/activestorage'

up.compiler('[file-input]', (element) => {

  const input = element.querySelector('input[type="file"]')
  const button = element.querySelector('[file-input--button]')
  const filename = element.querySelector('[file-input--filename]')
  const preview = element.querySelector('[file-input--preview]')
  const previewImage = preview.querySelector('img')
  const previewTemplate = element.querySelector('[file-input--preview-template]')

  const currentlyUploading = []

  function onDragOver(event) {
    event.preventDefault()
  }

  function onDrop(event) {
    event.preventDefault()
    input.files = event.dataTransfer.files
    uploadFiles()
  }

  function pickFile() {
    input.click()
  }

  function uploadFiles() {
    const files = Array.from(input.files)

    if (!input.multiple) {
      element.querySelectorAll(`input[type='hidden'][name="${input.name}"]`).forEach(hiddenInput => {
        if (hiddenInput.value) {
          hiddenInput.remove()
        }
      })
    }

    currentlyUploading.push(...files)
    updateUploadingState()

    files.forEach(file => {
      const controller = new DirectUploadController(input, file)
      controller.start(error => uploadFinished(file, error))
      displayFile(file, controller)
    })

    input.value = null
  }

  function uploadFinished(file, error) {
    const index = currentlyUploading.indexOf(file)
    currentlyUploading.splice(index, 1)

    if (error) {
      input.setCustomValidity(`Die Datei ${file.name} konnte nicht hochgeladen werden.`)
      input.reportValidity()
    }

    updateUploadingState()
  }

  function updateUploadingState() {
    if (currentlyUploading.length) {
      input.setAttribute('data-is-uploading', 'true')
    } else {
      input.removeAttribute('data-is-uploading')
      up.emit(input.form, 'uploadFinished')
    }
  }

  function displayFile(file, directUploadController) {
    if (previewImage) {
      updatePreview()
    } else if (input.multiple) {
      // ActiveStorage adds the hidden input with input.insertAdjacentHTML('beforebegin', hiddenInput)
      // and then throws away the reference. This is the best way to get it again
      const hiddenInput = input.previousSibling
      addFileLink(file, hiddenInput)
    } else {
      updateFilename()
    }
  }

  function updatePreview() {
    if (!previewImage) return

    if (input.files.length === 1) {
      const file = input.files[0]

      readFileAsDataURL(file).then((dataURL) => {
        previewImage.src = dataURL
      })
    } else {
      previewImage.src = '//:0'
    }
  }

  function updateFilename() {
    const filenames = Array.from(input.files).map(file => file.name)
    filename.innerText = filenames.join(', ')
  }

  function addFileLink(file, hiddenInput) {
    const fragment = up.template.clone(previewTemplate)[0]

    const filenameElement = fragment.querySelector('[file-input-template--filename]')
    filenameElement.textContent = file.name

    fragment.appendChild(hiddenInput)
    hiddenInput.setAttribute('file-input-preview--hidden-input', 'true')

    readFileAsDataURL(file).then(dataURL => {
      const linkElement = fragment.querySelector('[file-input-template--link]')
      linkElement.setAttribute('href', dataURL)
      linkElement.setAttribute('target', '_blank')
    })

    preview.appendChild(fragment)
    up.hello(fragment)
  }

  function readFileAsDataURL(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.addEventListener('load', () => {
        resolve(reader.result)
      })
      reader.readAsDataURL(file)
    })
  }

  element.addEventListener('drop', onDrop)
  element.addEventListener('dragover', onDragOver)
  button.addEventListener('click', pickFile)
  input.addEventListener('change', uploadFiles)
})
